import * as turf from '@turf/turf';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import { formatDate, isValidDate, isLate } from 'utilities/common';

export const MakeMap = (container, center, interactive = true) => {
    return {
        container: container,
        style: 'mapbox://styles/envioid/cl84ds0fu000r15mmxg7eamsj',
        center: center ? [center[0], center[1]] : [118.005351, -2.325613],
        zoom: 4,
        interactive: interactive,
        maxBounds: [
            [94.36405868758938, -11.650356606220004],
            [141.95026998017508, 6.763051702954545],
        ],
    }
}

export const MakeCurveLine = (origin, destination) => {
    const radius = turf?.rhumbDistance(origin, destination);
    const midpoint = turf?.midpoint(origin, destination);
    const bearing = turf?.rhumbBearing(origin, destination) - 90;

    const point = turf?.rhumbDestination(midpoint, radius, bearing);
    return turf?.lineArc(
        point,
        turf?.distance(point, origin),
        turf?.bearing(point, destination),
        turf?.bearing(point, origin),
        { steps: 200 }
    );
}

export const MakeMarker = (loc, type, text, color = '#2f83ba', is_active = null) => {
    var el = document.createElement('div');
    el.className = 'mapboxgl-nvo-marker';
    el.innerHTML = `<div class="mapboxgl-nvo-point ${type} ${is_active ? "active" : ""} " style="background-color:${color};"><b>${text}</b></div>`;

    return new mapboxgl.Marker(el).setLngLat(loc);
}

export const GetDistance = (origin, destination) => {
    return turf.distance(origin, destination, { units: 'miles' });
}

export const PinColor = {
    new: '#2f83ba',
    process: '#f76707',
    arrived: '#2fb344',
    departed: '#f76707',
    manifested: '#f76707',
    on_pickup: '#f59f00',
    on_transit: '#f59f00',
    on_delivery: '#f76707',
    transit: '#2f83ba',
    delivered: '#2fb344',
    disputed: '#d63939',
    void: '#848484',
};

export const PinContent = (shipment, location, legs = null) => {
    let time = '';
    let status = '';

    if (legs) {
        time = `${isValidDate(legs?.ata_at) ? `<small class="text-warning">ATA: ${formatDate(legs?.ata_at)}</small>` : ''} ${isValidDate(legs?.atd_at) ? `<small class="text-warning">ATD: ${formatDate(legs?.atd_at)}</small>` : ''}`

        status = `<small>TYPE: ${legs?.type.replace('_point', '', 0)} POINT</small><small>STATUS: ${legs?.status}</small>`
    } else {
        time = `${isValidDate(shipment?.eta_at) ? `<small class="text-warning">ETA: ${formatDate(shipment?.eta_at)}</small>` : ''} ${isValidDate(shipment?.ata_at) ? `<small class="${isLate(shipment?.eta_at, shipment?.ata_at) ? 'text-danger' : 'text-success'}">ATA: ${formatDate(shipment?.ata_at)}</small>` : ''}`
    }

    return `<div class='tooltip-contentss'>
      <small>${location?.name}</small>
      <p>${location?.address}</p>

      <small>${location?.region?.district_name}, ${location?.region?.regency_name}, ${location?.region?.province_name
        }</small>
      <small>CP: ${location?.contact_person} / ${location?.phone_number}</small><br />
      ${status} ${time}
    </div>`;
};